import React from 'react';

const ActionCableContext = React.createContext({});

export default ActionCableContext;
